module.exports = __webpack_public_path__ + "img/pro_subscription_wave.3af01fe.png";